const documentInboxes = [
    {
        "uuid":"1",
        "createdOn":"2021-05-02T08:20:10.000Z",
        "appType":"change",
        "phase":"documentReview",
        "activity":"documentReview_S10",
        "customerNo":"00004",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "appNo":"A21070101",
        "urgent": true,
        "urgentDescription": "急件需求說明..................",
        "changeProductsNumber": 3,
        "changeRawMaterialsNumber": 3,
        "thisSeasonChangeTimes":2,
        "newSupplementItems":[
            {"nodeId":"3_assessmentProduct", "changeType":"原料異動", "item":"Natural Benefits 食安生技-椰子汁","subItem":"美國加州杏仁果", "reviewResult": "agree", "completedDate": "2022-02-18T00:00:00.000Z",
                "reviewDesc":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]
            },
        ],
        "chargeItems": [
            {"item":"changeDocumentReview", "amountDefault":1000, "amountModified":1000},
            {"item":"transportation", "amountDefault":1000, "amountModified":1000},
        ],
        "changes": [
            {
                "changeType":"customerBasicInformationChange",
                "description": "異動說明................",
                "customerBasicInfo":{
                    "individual":false,
                    "customerNo":"00020",
                    "customerName":"源天然股份有限公司",
                    "taxIdNo":"83793371",
                    "personInCharge":"羅永昌",
                    "registeredAddress":{
                        "country":"TW",
                        "zip":"958",
                        "city":"taitung",
                        "district":"池上鄉",
                        "street":"振興村11鄰145號"
                    },
                    "tel":"089-360960",
                    "standards":["tseyue","leezen"],
                    "subContractorFilledCompletely":"Y",
                    "qualityManagementDoc1":true,
                    "qualityManagementDoc2":true,
                    "qualityManagementDoc3":true,
                    "qualityManagementDoc4":"prepared",
                    "paymentAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234098"
                    },
                    "refundAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234110"
                    },
                    "commodityLabelStatements":[
                        {
                            "filename":"A供應商商品標示.pdf",
                            "description":"A供應商商品標示聲明"
                        },
                        {
                            "filename":"B供應商商品標示.pdf",
                            "description":"B供應商商品標示聲明"
                        },
                        {
                            "filename":"C供應商商品標示.pdf",
                            "description":"C供應商商品標示聲明"
                        },
                        {
                            "filename":"D供應商商品標示.pdf",
                            "description":"D供應商商品標示聲明"
                        },
                        {
                            "filename":"E供應商商品標示.pdf",
                            "description":"E供應商商品標示聲明"
                        },
                        {
                            "filename":"F供應商商品標示.pdf",
                            "description":"F供應商商品標示聲明"
                        }
                    ]
                },
            },
            {
                "changeType":"assessmentPlaceDataChange",
                "description": "異動說明................",
                "assessmentPlaces":[
                    {
                        "id":"1",
                        "name":"台東廠",
                        "personInCharge":"王小花",
                        "masterAddress":"958台東縣池上鄉振興二號產業道路",
                        "relationshipWithApplicant":"company",
                        "productLabelingTel":"02-7723-8001",
                        "factoryRegistration":"yes",
                        "contactPerson":"王小花",
                        "jobTitle":"行政專員",
                        "email":"anniewang@gmail.com",
                        "phoneNumber":"02-7723-8001",
                        "extension":"201 ~ 203",
                        "mobilePhone":"0911290098",
                        "fax":"02-7723-8002",
                        "passedManagementSystems":["iso2200","tqf","others"],
                        "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                        "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                        "passedManagementSystemCertificates":[
                            {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                            {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                        ],
                        "addresses":[
                            {
                                "country":"TW",
                                "zip":"11501",
                                "city":"taipei",
                                "district":"南港區",
                                "street":"三重路19-11號",
                                "mainAddress":true,
                                "fullAddress":"11501 台北市南港區三重路19-11號"
                            }
                        ],
                        "referenceDocument":{
                            "documentPoint1":"ready",
                            "documentPoint2":"ready",
                            "documentPoint3":"unused",
                            "documentPoint4":"ready",
                        },
                        "factoryFloorPlans":[
                            {
                                "id":"1",
                                "filename":"原料處理區及加工調理區.pdf",
                                "description":"原料處理區及加工調理區"
                            },
                            {
                                "id":"2",
                                "filename":"食品添加物室.jpeg",
                                "description":"食品添加物室"
                            }
                        ],
                        "productionLines":[
                            {
                                "id":"1",
                                "name":"果汁線",
                                "waterUse":"coolDown",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'Y',
                                "lubricantDescriptions":[
                                    {
                                        "id":"1",
                                        "name":"烤盤專用油",
                                        "element":"芥花油,大豆卵磷脂",
                                        "usage":"用於烤盤"
                                    },
                                    {
                                        "id":"2",
                                        "name":"YY潤滑劑",
                                        "element":"硫化鋅、石蠟、礦物油",
                                        "usage":"輸送帶鏈條"
                                    }
                                ]
                            },
                            {
                                "id":"2",
                                "name":"運動飲料線",
                                "waterUse":"others",
                                "waterUseDesc":"test111",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機111",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'N'
                            }
                        ]
                    }
                ],
            },
            {
                "changeType":"assessmentProductChange",
                "description": "異動說明................",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","documentDate":"2021-06-01T08:20:10.000Z", "dateDesc":"報告日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"organicCertificate","documentDate":"2021-07-01T08:20:10.000Z", "dateDesc":"有效日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"importOrganicConsentDoc","documentDate":"2020-03-01T08:20:10.000Z", "dateDesc":"文件日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"enterFoodPermissionNotice","documentDate":"2020-01-01T08:20:10.000Z", "dateDesc":"進口日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":true,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","documentDate":"2021-06-01T08:20:10.000Z", "dateDesc":"報告日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"organicCertificate","documentDate":"2021-07-01T08:20:10.000Z", "dateDesc":"有效日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"importOrganicConsentDoc","documentDate":"2020-03-01T08:20:10.000Z", "dateDesc":"文件日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"enterFoodPermissionNotice","documentDate":"2020-01-01T08:20:10.000Z", "dateDesc":"進口日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","documentDate":"2021-06-01T08:20:10.000Z", "dateDesc":"報告日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"organicCertificate","documentDate":"2021-07-01T08:20:10.000Z", "dateDesc":"有效日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"importOrganicConsentDoc","documentDate":"2020-03-01T08:20:10.000Z", "dateDesc":"文件日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"enterFoodPermissionNotice","documentDate":"2020-01-01T08:20:10.000Z", "dateDesc":"進口日期", "uploadDate": "2022-02-18T00:00:00.000Z"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                ]
            },
            {
                "changeType":"rawMaterialChange",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "type":"material",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "documentDate":"2021-06-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "documentDate":"2021-01-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                ],
                                "flag": "delete",
                            },
                            {
                                "id":"2",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2,
                                "flag": "edit",
                            },
                            {
                                "id":"3",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3,
                                "flag": "edit",
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":true,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "semiFinishedProducts":[
                            {
                                "name":"半成品1",
                                "rawMaterials":[
                                    {
                                        "id":"1",
                                        "name":"豆蓉粉(新版)",
                                        "storageCondition":"roomTemperature",
                                        "composition":"",
                                        "domesticVendor":"穎昌食品有限公司(新和美)",
                                        "importer":"",
                                        "manufacturer":"穎昌食品有限公司(新和美)",
                                        "originPlace":"台灣",
                                        "additiveLicenseNumber":"",
                                        "addRatio":9,
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":1,
                                        "relatedDocuments":[
                                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "documentDate":"2021-06-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "documentDate":"2021-01-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                        ],
                                        "flag": "delete",
                                    },
                                    {
                                        "id":"2",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"信成股份有限公司",
                                        "importer":"信成股份有限公司",
                                        "manufacturer":"TERRA NOVA TRADING INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":2,
                                        "flag": "edit",
                                    },
                                    {
                                        "id":"3",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"爾邦得有限公司",
                                        "importer":"爾邦得有限公司",
                                        "manufacturer":"TERRA NOVA TRADING INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":3,
                                        "flag": "edit",
                                    },
                                    {
                                        "id":"4",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"信和股份有限公司",
                                        "importer":"信和股份有限公司",
                                        "manufacturer":"RPAC,LLC",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":4
                                    },
                                    {
                                        "id":"5",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"信和股份有限公司",
                                        "importer":"信和股份有限公司",
                                        "manufacturer":"VANN FAMLLY ORCHARDS",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":5
                                    },
                                    {
                                        "id":"6",
                                        "name":"甜扁桃仁粒",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"成久旺股份有限公司",
                                        "importer":"成久旺股份有限公司",
                                        "manufacturer":"TWIN COMMODITIES,INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":6
                                    },
                                    {
                                        "id":"7",
                                        "name":"帶皮杏仁粒",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"昇祥股份有限公司",
                                        "importer":"昇祥股份有限公司",
                                        "manufacturer":"美國加州皮爾農場公司",
                                        "originPlace":"美國加州",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":7
                                    },
                                    {
                                        "id":"8",
                                        "name":"有機生糙米粉(台灣)",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"青田農產有限公司",
                                        "importer":"",
                                        "manufacturer":"青田農產有限公司",
                                        "originPlace":"台灣",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":8
                                    },
                                    {
                                        "id":"9",
                                        "name":"精製椰子油",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"禾發實業有限公司",
                                        "importer":"禾發實業有限公司",
                                        "manufacturer":"OLEO-FATS, INCORPORATED",
                                        "originPlace":"菲律賓",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":9
                                    },
                                    {
                                        "id":"10",
                                        "name":"杏仁細粉",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"迦得貿易實業有限公司",
                                        "importer":"迦得貿易實業有限公司",
                                        "manufacturer":"Treehouse California Almonds LLC",
                                        "originPlace":"菲律賓",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":10
                                    },
                                    {
                                        "id":"11",
                                        "name":"杏仁粉(細)",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"成久旺股份有限公司",
                                        "importer":"成久旺股份有限公司",
                                        "manufacturer":"Treehouse California Almonds LLC",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":11
                                    },
                                    {
                                        "id":"12",
                                        "name":"混合濃縮生育醇",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"信意企業股份有限公司",
                                        "importer":"信意企業股份有限公司",
                                        "manufacturer":"CARGILL INCORPORATED",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                        "processingAid":"N",
                                        "accessory":"N"
                                    }
                                ]
                            },
                            {
                                "name":"半成品2",
                            }
                        ],
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "documentDate":"2021-06-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "documentDate":"2021-01-01T08:20:10.000Z", "uploadDate": "2022-02-18T00:00:00.000Z"},
                                ],
                                "flag": "delete",
                            },
                            {
                                "id":"2",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2,
                                "flag": "edit",
                            },
                            {
                                "id":"3",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3,
                                "flag": "edit",
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"reduce",
                "reduceTypes": ["productionLine", "product/packagingMethod/spec"],
                "reducedProductionLines": [
                    {
                        assessmentPlace:'台東廠',
                        productionLine:'果汁線',
                        status:'通過',
                        productName:'Natural Benefits 食安生技-椰子汁, ' +
                            'Natural Benefits 純在-蔬菜綜合果汁, ' +
                            'Natural Benefits 食安生技-芒果綜合果汁',
                        certificateEffectiveDate:'2022/10/10',
                    },
                    {
                        assessmentPlace:'台東廠',
                        productionLine:'運動飲料線',
                        status:'通過',
                        productName:'維他露 舒跑運動飲料, ' +
                            '黑松 FIN乳酸菌補給飲料',
                        certificateEffectiveDate:'2022/10/10',
                    },
                    {
                        assessmentPlace:'屏東廠',
                        productionLine:'堅果線',
                        status:'暫時終止',
                        productName:'每日堅果禮盒, ' +
                            '堅果罐系列',
                        certificateEffectiveDate:'2023/11/10',
                    },
                ],
                "reducedProducts": [
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'玻璃瓶',
                        spec:'300ml/瓶',
                        tseyueStandard:true,
                        channel:'里仁',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'玻璃瓶',
                        spec:'1000ml/瓶',
                        tseyueStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'塑膠袋',
                        spec:'1公斤/包',
                        tseyueStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'塑膠袋',
                        spec:'2公斤/包',
                        tseyueStandard:true,
                        channel:'里仁',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'桂圓四物飲',
                        packagingMethod:'玻璃瓶',
                        spec:'150ml/瓶',
                        tseyueStandard:true,
                        leezenStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'backEnd',
                    },
                    {
                        productName:'桂圓四物飲',
                        packagingMethod:'玻璃瓶',
                        spec:'250ml/瓶',
                        tseyueStandard:true,
                        leezenStandard:true,
                        channel:'里仁、全家',
                        status:'暫時終止',
                        processStatus: 'backEnd',
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"endAssessment",
                "endAssessments": [
                    {
                        "name": "台東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2022-10-10T00:00:00.000Z",
                    },
                    {
                        "name": "屏東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2023-11-10T00:00:00.000Z",
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"postponeInspection",
                "postponedInspections": [
                    {
                        "id":"1",
                        "name":"台東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q1",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q2",
                    },
                    {
                        "id":"2",
                        "name":"屏東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q2",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q3",
                    }
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"resumeSuspend",
                "resumeTypes": ["resumeAssessmentPlace", "resumeAssessmentProduct"],
                "suspendAssessmentPlaces":[
                    {"name": "嘉義廠", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "雲林廠", "suspendDate": "2021-08-05T00:00:00.000Z"},
                ],
                "suspendAssessmentProducts": [
                    {"name": "產品1", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "產品2", "suspendDate": "2021-08-05T00:00:00.000Z"},
                    {"name": "產品3", "suspendDate": "2021-12-25T00:00:00.000Z"},
                    {"name": "產品4", "suspendDate": "2022-01-11T00:00:00.000Z"},
                ],
                "description": "異動說明................"
            },
        ],
        "assessmentPlaces":[
            {
                "id":"1",
                "name":"台東廠",
                "personInCharge":"王小花",
                "masterAddress":"958台東縣池上鄉振興二號產業道路",
                "relationshipWithApplicant":"company",
                "productLabelingTel":"02-7723-8001",
                "factoryRegistration":"yes",
                "contactPerson":"王小花",
                "jobTitle":"行政專員",
                "email":"anniewang@gmail.com",
                "phoneNumber":"02-7723-8001",
                "extension":"201 ~ 203",
                "mobilePhone":"0911290098",
                "fax":"02-7723-8002",
                "passedManagementSystems":["iso2200","tqf","others"],
                "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                "passedManagementSystemCertificates":[
                    {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                    {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                ],
                "addresses":[
                    {
                        "country":"TW",
                        "zip":"11501",
                        "city":"taipei",
                        "district":"南港區",
                        "street":"三重路19-11號",
                        "mainAddress":true,
                        "fullAddress":"11501 台北市南港區三重路19-11號"
                    }
                ],
                "referenceDocument":{
                    "documentPoint1":"ready",
                    "documentPoint2":"ready",
                    "documentPoint3":"unused",
                    "documentPoint4":"ready",
                },
                "factoryFloorPlans":[
                    {
                        "id":"1",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"原料處理區及加工調理區.pdf",
                        "description":"原料處理區及加工調理區"
                    },
                    {
                        "id":"2",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"食品添加物室.jpeg",
                        "description":"食品添加物室"
                    }
                ],
                "productionLines":[
                    {
                        "id":"1",
                        "name":"果汁線",
                        "waterUse":"coolDown",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'Y',
                        "lubricantDescriptions":[
                            {
                                "id":"1",
                                "name":"烤盤專用油",
                                "element":"芥花油,大豆卵磷脂",
                                "usage":"用於烤盤"
                            },
                            {
                                "id":"2",
                                "name":"YY潤滑劑",
                                "element":"硫化鋅、石蠟、礦物油",
                                "usage":"輸送帶鏈條"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"運動飲料線",
                        "waterUse":"others",
                        "waterUseDesc":"test111",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機111",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'N'
                    }
                ]
            }
        ],
    },
    {
        "uuid":"2",
        "createdOn":"2021-05-03T08:20:10.000Z",
        "appType":"change",
        "phase":"documentReview",
        "activity":"documentReview_S20",
        "customerNo":"00004",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "appNo":"A21070102",
        "firstDecision":"uncompleted",
        "firstComments":"關於大家比較關心的 iPhone 系統升級，這次升級之後會發現整個系統介面變得不太衣一樣，FaceTime 音訊和視訊功能的強大更新，像是多了新的麥克風模式「語音隔離」與「寬廣頻譜」模式，我比較有感的還是 FaceTime 上的「人像」模式，並且支援例如 Webex、Zoom 和 WhatsApp等應用程式。",
        "sampling":"Y",
        "onSiteInspection":"Y",
        "inspectionNote":"指件查驗：根據派驗報單主管人員批註之至少開驗件數、過磅件數、通扞件數之範圍內自行指定查驗。",
        "samplingPrinciple":" 產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品",
        "timeComplianceRate":"onTime",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "finishedGoodTestName":"杏仁玄米餅",
                "testName":"杏仁玄米餅",
                "manufacture":"台東廠",
                "originPlace":"台灣",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"intertek",
                "paymentUnit":"tseyue",
                "samplingFrequency":"oddYear",
                "samplingTiming":false,
                "samplingDate":"2021-09-02T08:20:10.000Z"
            },
            {
                "product":"02",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "manufacture":"原料1製造商",
                "originPlace":"美國",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "samplingFrequency":"year",
                "samplingTiming":true,
                "samplingDate":"2021-09-02T08:20:10.000Z"
            }
        ],
        "newSupplementItems":[
            {"nodeId":"3_assessmentProduct", "changeType":"原料異動", "item":"Natural Benefits 食安生技-椰子汁","subItem":"美國加州杏仁果", "reviewDesc":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)"},
        ],
        "changes": [
            {
                "changeType":"customerBasicInformationChange",
                "description": "異動說明................",
                "customerBasicInfo":{
                    "individual":false,
                    "customerNo":"00020",
                    "customerName":"源天然股份有限公司",
                    "taxIdNo":"83793371",
                    "personInCharge":"羅永昌",
                    "registeredAddress":{
                        "country":"TW",
                        "zip":"958",
                        "city":"taitung",
                        "district":"池上鄉",
                        "street":"振興村11鄰145號"
                    },
                    "tel":"089-360960",
                    "standards":["tseyue","leezen"],
                    "subContractorFilledCompletely":"Y",
                    "qualityManagementDoc1":true,
                    "qualityManagementDoc2":true,
                    "qualityManagementDoc3":true,
                    "qualityManagementDoc4":"prepared",
                    "paymentAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234098"
                    },
                    "refundAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234110"
                    },
                    "commodityLabelStatements":[
                        {
                            "filename":"A供應商商品標示.pdf",
                            "description":"A供應商商品標示聲明"
                        },
                        {
                            "filename":"B供應商商品標示.pdf",
                            "description":"B供應商商品標示聲明"
                        },
                        {
                            "filename":"C供應商商品標示.pdf",
                            "description":"C供應商商品標示聲明"
                        },
                        {
                            "filename":"D供應商商品標示.pdf",
                            "description":"D供應商商品標示聲明"
                        },
                        {
                            "filename":"E供應商商品標示.pdf",
                            "description":"E供應商商品標示聲明"
                        },
                        {
                            "filename":"F供應商商品標示.pdf",
                            "description":"F供應商商品標示聲明"
                        }
                    ]
                },
            },
            {
                "changeType":"assessmentPlaceDataChange",
                "description": "異動說明................",
                "assessmentPlaces":[
                    {
                        "id":"1",
                        "name":"台東廠",
                        "personInCharge":"王小花",
                        "masterAddress":"958台東縣池上鄉振興二號產業道路",
                        "relationshipWithApplicant":"company",
                        "productLabelingTel":"02-7723-8001",
                        "factoryRegistration":"yes",
                        "contactPerson":"王小花",
                        "jobTitle":"行政專員",
                        "email":"anniewang@gmail.com",
                        "phoneNumber":"02-7723-8001",
                        "extension":"201 ~ 203",
                        "mobilePhone":"0911290098",
                        "fax":"02-7723-8002",
                        "passedManagementSystems":["iso2200","tqf","others"],
                        "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                        "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                        "passedManagementSystemCertificates":[
                            {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                            {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                        ],
                        "addresses":[
                            {
                                "country":"TW",
                                "zip":"11501",
                                "city":"taipei",
                                "district":"南港區",
                                "street":"三重路19-11號",
                                "mainAddress":true,
                                "fullAddress":"11501 台北市南港區三重路19-11號"
                            }
                        ],
                        "referenceDocument":{
                            "documentPoint1":"ready",
                            "documentPoint2":"ready",
                            "documentPoint3":"unused",
                            "documentPoint4":"ready",
                        },
                        "factoryFloorPlans":[
                            {
                                "id":"1",
                                "filename":"原料處理區及加工調理區.pdf",
                                "description":"原料處理區及加工調理區"
                            },
                            {
                                "id":"2",
                                "filename":"食品添加物室.jpeg",
                                "description":"食品添加物室"
                            }
                        ],
                        "productionLines":[
                            {
                                "id":"1",
                                "name":"果汁線",
                                "waterUse":"coolDown",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'Y',
                                "lubricantDescriptions":[
                                    {
                                        "id":"1",
                                        "name":"烤盤專用油",
                                        "element":"芥花油,大豆卵磷脂",
                                        "usage":"用於烤盤"
                                    },
                                    {
                                        "id":"2",
                                        "name":"YY潤滑劑",
                                        "element":"硫化鋅、石蠟、礦物油",
                                        "usage":"輸送帶鏈條"
                                    }
                                ]
                            },
                            {
                                "id":"2",
                                "name":"運動飲料線",
                                "waterUse":"others",
                                "waterUseDesc":"test111",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機111",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'N'
                            }
                        ]
                    }
                ],
            },
            {
                "changeType":"assessmentProductChange",
                "description": "異動說明................",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":true,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                ]
            },
            {
                "changeType":"rawMaterialChange",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "type":"material",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":true,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "semiFinishedProducts":[
                            {
                                "name":"半成品1",
                                "rawMaterials":[
                                    {
                                        "id":"1",
                                        "name":"豆蓉粉(新版)",
                                        "storageCondition":"roomTemperature",
                                        "composition":"",
                                        "domesticVendor":"穎昌食品有限公司(新和美)",
                                        "importer":"",
                                        "manufacturer":"穎昌食品有限公司(新和美)",
                                        "originPlace":"台灣",
                                        "additiveLicenseNumber":"",
                                        "addRatio":9,
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":1,
                                        "relatedDocuments":[
                                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                        ]
                                    },
                                    {
                                        "id":"2",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"信成股份有限公司",
                                        "importer":"信成股份有限公司",
                                        "manufacturer":"TERRA NOVA TRADING INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":2
                                    },
                                    {
                                        "id":"3",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"爾邦得有限公司",
                                        "importer":"爾邦得有限公司",
                                        "manufacturer":"TERRA NOVA TRADING INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":3
                                    },
                                    {
                                        "id":"4",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"信和股份有限公司",
                                        "importer":"信和股份有限公司",
                                        "manufacturer":"RPAC,LLC",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":4
                                    },
                                    {
                                        "id":"5",
                                        "name":"美國加州杏仁果",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"信和股份有限公司",
                                        "importer":"信和股份有限公司",
                                        "manufacturer":"VANN FAMLLY ORCHARDS",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":5
                                    },
                                    {
                                        "id":"6",
                                        "name":"甜扁桃仁粒",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"成久旺股份有限公司",
                                        "importer":"成久旺股份有限公司",
                                        "manufacturer":"TWIN COMMODITIES,INC.",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":6
                                    },
                                    {
                                        "id":"7",
                                        "name":"帶皮杏仁粒",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"昇祥股份有限公司",
                                        "importer":"昇祥股份有限公司",
                                        "manufacturer":"美國加州皮爾農場公司",
                                        "originPlace":"美國加州",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":7
                                    },
                                    {
                                        "id":"8",
                                        "name":"有機生糙米粉(台灣)",
                                        "storageCondition":"refrigeration",
                                        "domesticVendor":"青田農產有限公司",
                                        "importer":"",
                                        "manufacturer":"青田農產有限公司",
                                        "originPlace":"台灣",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":8
                                    },
                                    {
                                        "id":"9",
                                        "name":"精製椰子油",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"禾發實業有限公司",
                                        "importer":"禾發實業有限公司",
                                        "manufacturer":"OLEO-FATS, INCORPORATED",
                                        "originPlace":"菲律賓",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":9
                                    },
                                    {
                                        "id":"10",
                                        "name":"杏仁細粉",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"迦得貿易實業有限公司",
                                        "importer":"迦得貿易實業有限公司",
                                        "manufacturer":"Treehouse California Almonds LLC",
                                        "originPlace":"菲律賓",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":10
                                    },
                                    {
                                        "id":"11",
                                        "name":"杏仁粉(細)",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"成久旺股份有限公司",
                                        "importer":"成久旺股份有限公司",
                                        "manufacturer":"Treehouse California Almonds LLC",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"",
                                        "processingAid":"N",
                                        "accessory":"N",
                                        "ingredientOrder":11
                                    },
                                    {
                                        "id":"12",
                                        "name":"混合濃縮生育醇",
                                        "storageCondition":"roomTemperature",
                                        "domesticVendor":"信意企業股份有限公司",
                                        "importer":"信意企業股份有限公司",
                                        "manufacturer":"CARGILL INCORPORATED",
                                        "originPlace":"美國",
                                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                        "processingAid":"N",
                                        "accessory":"N"
                                    }
                                ]
                            },
                            {
                                "name":"半成品2",
                            }
                        ],
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"], "productStatus": "approve"},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX", "productStatus": "suspend"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"reduce",
                "reduceTypes": ["productionLine", "product/packagingMethod/spec"],
                "reducedProductionLines": [
                    {
                        assessmentPlace:'台東廠',
                        productionLine:'果汁線',
                        status:'通過',
                        productName:'Natural Benefits 食安生技-椰子汁, ' +
                            'Natural Benefits 純在-蔬菜綜合果汁, ' +
                            'Natural Benefits 食安生技-芒果綜合果汁',
                        certificateEffectiveDate:'2022/10/10',
                    },
                    {
                        assessmentPlace:'台東廠',
                        productionLine:'運動飲料線',
                        status:'通過',
                        productName:'維他露 舒跑運動飲料, ' +
                            '黑松 FIN乳酸菌補給飲料',
                        certificateEffectiveDate:'2022/10/10',
                    },
                    {
                        assessmentPlace:'屏東廠',
                        productionLine:'堅果線',
                        status:'暫時終止',
                        productName:'每日堅果禮盒, ' +
                            '堅果罐系列',
                        certificateEffectiveDate:'2023/11/10',
                    },
                ],
                "reducedProducts": [
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'玻璃瓶',
                        spec:'300ml/瓶',
                        tseyueStandard:true,
                        channel:'里仁',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'玻璃瓶',
                        spec:'1000ml/瓶',
                        tseyueStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'塑膠袋',
                        spec:'1公斤/包',
                        tseyueStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'杏仁玄米餅',
                        packagingMethod:'塑膠袋',
                        spec:'2公斤/包',
                        tseyueStandard:true,
                        channel:'里仁',
                        status:'通過',
                        processStatus: 'frontEnd',
                        BackEndProductName: '杏仁玄米餅',
                    },
                    {
                        productName:'桂圓四物飲',
                        packagingMethod:'玻璃瓶',
                        spec:'150ml/瓶',
                        tseyueStandard:true,
                        leezenStandard:true,
                        channel:'里仁、全家',
                        status:'通過',
                        processStatus: 'backEnd',
                    },
                    {
                        productName:'桂圓四物飲',
                        packagingMethod:'玻璃瓶',
                        spec:'250ml/瓶',
                        tseyueStandard:true,
                        leezenStandard:true,
                        channel:'里仁、全家',
                        status:'暫時終止',
                        processStatus: 'backEnd',
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"endAssessment",
                "endAssessments": [
                    {
                        "name": "台東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2022-10-10T00:00:00.000Z",
                    },
                    {
                        "name": "屏東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2023-11-10T00:00:00.000Z",
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"postponeInspection",
                "postponedInspections": [
                    {
                        "id":"1",
                        "name":"台東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q1",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q2",
                    },
                    {
                        "id":"2",
                        "name":"屏東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q2",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q3",
                    }
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"resumeSuspend",
                "resumeTypes": ["resumeAssessmentPlace", "resumeAssessmentProduct"],
                "suspendAssessmentPlaces":[
                    {"name": "嘉義廠", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "雲林廠", "suspendDate": "2021-08-05T00:00:00.000Z"},
                ],
                "suspendAssessmentProducts": [
                    {"name": "產品1", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "產品2", "suspendDate": "2021-08-05T00:00:00.000Z"},
                    {"name": "產品3", "suspendDate": "2021-12-25T00:00:00.000Z"},
                    {"name": "產品4", "suspendDate": "2022-01-11T00:00:00.000Z"},
                ],
                "description": "異動說明................"
            },
        ],
        "assessmentPlaces":[
            {
                "id":"1",
                "name":"台東廠",
                "personInCharge":"王小花",
                "masterAddress":"958台東縣池上鄉振興二號產業道路",
                "relationshipWithApplicant":"company",
                "productLabelingTel":"02-7723-8001",
                "factoryRegistration":"yes",
                "contactPerson":"王小花",
                "jobTitle":"行政專員",
                "email":"anniewang@gmail.com",
                "phoneNumber":"02-7723-8001",
                "extension":"201 ~ 203",
                "mobilePhone":"0911290098",
                "fax":"02-7723-8002",
                "passedManagementSystems":["iso2200","tqf","others"],
                "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                "passedManagementSystemCertificates":[
                    {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                    {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                ],
                "addresses":[
                    {
                        "country":"TW",
                        "zip":"11501",
                        "city":"taipei",
                        "district":"南港區",
                        "street":"三重路19-11號",
                        "mainAddress":true,
                        "fullAddress":"11501 台北市南港區三重路19-11號"
                    }
                ],
                "referenceDocument":{
                    "documentPoint1":"ready",
                    "documentPoint2":"ready",
                    "documentPoint3":"unused",
                    "documentPoint4":"ready",
                },
                "factoryFloorPlans":[
                    {
                        "id":"1",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"原料處理區及加工調理區.pdf",
                        "description":"原料處理區及加工調理區"
                    },
                    {
                        "id":"2",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"食品添加物室.jpeg",
                        "description":"食品添加物室"
                    }
                ],
                "productionLines":[
                    {
                        "id":"1",
                        "name":"果汁線",
                        "waterUse":"coolDown",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'Y',
                        "lubricantDescriptions":[
                            {
                                "id":"1",
                                "name":"烤盤專用油",
                                "element":"芥花油,大豆卵磷脂",
                                "usage":"用於烤盤"
                            },
                            {
                                "id":"2",
                                "name":"YY潤滑劑",
                                "element":"硫化鋅、石蠟、礦物油",
                                "usage":"輸送帶鏈條"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"運動飲料線",
                        "waterUse":"others",
                        "waterUseDesc":"test111",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機111",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'N'
                    }
                ]
            }
        ],
    },
    {
        "uuid":"3",
        "createdOn":"2021-06-12T08:20:10.000Z",
        "appType":"renewal",
        "phase":"documentReview",
        "activity":"documentReview_S10",
        "customerNo":"00004",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "appNo":"A21070201",
        "remainingDays":-3,
        "confirmStatement": true,
        "productionLineRemoves": [
            {
                "productionLine": "果汁線",
                "removes":[
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "approve",
                    },
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "improvement",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "suspend",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "飲料線",
                "removes":[
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "360ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "1000ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "餅乾線",
                "removes":[
                    {
                        "name": "杏仁玄米餅",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "餅乾線",
                        "processStatus": "backEnd",
                        "packaging": "paperBag",
                        "spec": "200/盒",
                        "channel": ["leezen"],
                        "status": "approve",
                    },
                ]
            },
        ],
        "productAttachmentOverdueList": [
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "description": "說明說明說明說明說明說明說明說明說明說明說明說明說明說明",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2021-12-20T08:00:00.000Z",
                "description": "說明.....",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-10-30T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "alcoholContentTestReport",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2022-01-09T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "桂圓四物飲",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案51.pdf",
                "validDateOld": "2021-12-05T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2022-01-05T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
        ],
        "rawMaterialAttachmentOverdueList": [
            {
                "rawMaterial": "豆蓉粉",
                "product": "杏仁玄米餅",
                "attachmentType": "inspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "composition":"",
                "domesticVendor":"穎昌食品有限公司(新和美)",
                "importer":"",
                "manufacturer":"穎昌食品有限公司(新和美)",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "addRatio":9,
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":1,
                "relatedDocuments":[
                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                ],
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "rawMaterial": "美國加州杏仁果",
                "product": "杏仁玄米餅、杏仁巧克力酥",
                "attachmentType": "foodAdditiveLicense",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "有效日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "domesticVendor":"信成股份有限公司",
                "importer":"信成股份有限公司",
                "manufacturer":"TERRA NOVA TRADING INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":2,
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "有機生糙米粉(台灣)",
                "product": "杏仁巧克力酥",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "進口日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"青田農產有限公司",
                "importer":"",
                "manufacturer":"青田農產有限公司",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":8,
                "validDateNew": "2022-01-20T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "甜扁桃仁粒",
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"TWIN COMMODITIES,INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":6,
                "validDateNew": "2021-11-30T08:00:00.000Z",
                "description": "說明......",
                "disable": true,
            },
            {
                "rawMaterial": "杏仁粉(細)",
                "product": "杏仁玄米餅",
                "attachmentType": "organicCertificate",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"roomTemperature",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"Treehouse California Almonds LLC",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":11,
                "validDateNew": "2022-02-09T08:00:00.000Z",
                "description": "說明......",
            },
        ]
    },
    {
        "uuid":"4",
        "createdOn":"2021-06-12T08:20:10.000Z",
        "appType":"renewal",
        "phase":"documentReview",
        "activity":"documentReview_S20",
        "customerNo":"00002",
        "customerName":"豆之家食品科技股份有限公司",
        "assessmentPlace":"桃園廠",
        "appNo":"A21070202",
        "remainingDays":-1,
        "firstDecision": "uncompleted",
        "timeComplianceRate":"onTime",
        "decision": "completed",
        "confirmStatement": true,
        "productionLineRemoves": [
            {
                "productionLine": "果汁線",
                "removes":[
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "approve",
                    },
                    {
                        "name": "Natural Benefits 食安生技-椰子汁",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "食安生技-椰子汁",
                        "status": "improvement",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "250ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "suspend",
                    },
                    {
                        "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "果汁線",
                        "processStatus": "frontEnd",
                        "packaging": "tetraPak",
                        "spec": "360ml/包",
                        "channel": ["leezen"],
                        "backEndName": "純在葡萄柚蘋果綠茶",
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "飲料線",
                "removes":[
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "360ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                    {
                        "name": "桂圓四物飲",
                        "tseyueLevel": "",
                        "leezenLevel": "organic",
                        "productionLine": "飲料線",
                        "processStatus": "backEnd",
                        "packaging": "glassBottle",
                        "spec": "1000ml/瓶",
                        "channel": ["leezen", "family"],
                        "status": "approve",
                    },
                ]
            },
            {
                "productionLine": "餅乾線",
                "removes":[
                    {
                        "name": "杏仁玄米餅",
                        "tseyueLevel": "doubleClean",
                        "leezenLevel": "organic",
                        "productionLine": "餅乾線",
                        "processStatus": "backEnd",
                        "packaging": "paperBag",
                        "spec": "200/盒",
                        "channel": ["leezen"],
                        "status": "approve",
                    },
                ]
            },
        ],
        "productAttachmentOverdueList": [
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "description": "說明說明說明說明說明說明說明說明說明說明說明說明說明說明",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-11-11T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2021-12-20T08:00:00.000Z",
                "description": "說明.....",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2021-10-30T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "杏仁玄米餅",
                "attachmentType": "alcoholContentTestReport",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "報告日期",
                "validDateNew": "2022-01-09T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "product": "桂圓四物飲",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案51.pdf",
                "validDateOld": "2021-12-05T08:00:00.000Z",
                "dateType": "文件日期",
                "validDateNew": "2022-01-05T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
        ],
        "rawMaterialAttachmentOverdueList": [
            {
                "rawMaterial": "豆蓉粉",
                "product": "杏仁玄米餅",
                "attachmentType": "inspectionReport",
                "filenameOld": "檔案11.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "報告日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "composition":"",
                "domesticVendor":"穎昌食品有限公司(新和美)",
                "importer":"",
                "manufacturer":"穎昌食品有限公司(新和美)",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "addRatio":9,
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":1,
                "relatedDocuments":[
                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                ],
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
                "history": [
                    {
                        "reviewResult": "unQualified",
                        "replyDate": "2022-01-25T11:38:00.000Z",
                        "supplementDesc": "補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明補件說明",
                        "customerDesc": "客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明客戶說明",
                    },
                ]
            },
            {
                "rawMaterial": "美國加州杏仁果",
                "product": "杏仁玄米餅、杏仁巧克力酥",
                "attachmentType": "foodAdditiveLicense",
                "filenameOld": "檔案12.pdf",
                "validDateOld": "2021-10-01T08:00:00.000Z",
                "dateType": "有效日期",
                "type":"material",
                "storageCondition":"roomTemperature",
                "domesticVendor":"信成股份有限公司",
                "importer":"信成股份有限公司",
                "manufacturer":"TERRA NOVA TRADING INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":2,
                "validDateNew": "2021-12-01T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "有機生糙米粉(台灣)",
                "product": "杏仁巧克力酥",
                "attachmentType": "enterFoodPermissionNotice",
                "filenameOld": "檔案21.pdf",
                "validDateOld": "2021-11-20T08:00:00.000Z",
                "dateType": "進口日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"青田農產有限公司",
                "importer":"",
                "manufacturer":"青田農產有限公司",
                "originPlace":"台灣",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":8,
                "validDateNew": "2022-01-20T08:00:00.000Z",
                "description": "說明......",
            },
            {
                "rawMaterial": "甜扁桃仁粒",
                "product": "杏仁玄米餅",
                "attachmentType": "importOrganicConsentDoc",
                "filenameOld": "檔案31.pdf",
                "validDateOld": "2021-09-30T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"refrigeration",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"TWIN COMMODITIES,INC.",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":6,
                "validDateNew": "2021-11-30T08:00:00.000Z",
                "description": "說明......",
                "disable": true,
            },
            {
                "rawMaterial": "杏仁粉(細)",
                "product": "杏仁玄米餅",
                "attachmentType": "organicCertificate",
                "filenameOld": "檔案41.pdf",
                "validDateOld": "2021-12-09T08:00:00.000Z",
                "dateType": "有效日期",
                "storageCondition":"roomTemperature",
                "domesticVendor":"成久旺股份有限公司",
                "importer":"成久旺股份有限公司",
                "manufacturer":"Treehouse California Almonds LLC",
                "originPlace":"美國",
                "additiveLicenseNumber":"",
                "processingAid":"N",
                "accessory":"N",
                "ingredientOrder":11,
                "validDateNew": "2022-02-09T08:00:00.000Z",
                "description": "說明......",
            },
        ]
    },
    {
        "uuid":"5",
        "createdOn":"2021-07-12T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentReview",
        "activity":"documentReview_S10",
        "customerNo":"00004",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "appNo":"A21080203",
        "allSupplements":[
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "completedDate":"2021-07-21T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "newSupplementItems":[
            {"nodeId":"3_assessmentProduct", "category":"評鑑產品", "item":"Natural Benefits 食安生技-椰子汁","comments":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)"},
        ],
        "remainingDays":-3
    },
    {
        "uuid":"6",
        "createdOn":"2021-07-02T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentReview",
        "activity":"documentReview_S20",
        "customerNo":"00002",
        "customerName":"豆之家食品科技股份有限公司",
        "assessmentPlace":"桃園廠",
        "appNo":"A21080202",
        "firstDecision":"uncompleted",
        "firstComments":"關於大家比較關心的 iPhone 系統升級，這次升級之後會發現整個系統介面變得不太衣一樣，FaceTime 音訊和視訊功能的強大更新，像是多了新的麥克風模式「語音隔離」與「寬廣頻譜」模式，我比較有感的還是 FaceTime 上的「人像」模式，並且支援例如 Webex、Zoom 和 WhatsApp等應用程式。",
        "sampling":"Y",
        "onSiteInspection":"Y",
        "inspectionNote":"指件查驗：根據派驗報單主管人員批註之至少開驗件數、過磅件數、通扞件數之範圍內自行指定查驗。",
        "samplingPrinciple":" 產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品",
        "newSupplementItems":[
            {"nodeId":"3_assessmentProduct", "category":"評鑑產品", "item":"桂圓四物飲","subItem":"美國加州杏仁果","comments":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)"},
        ],
        "timeComplianceRate":"onTime",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "finishedGoodTestName":"杏仁玄米餅",
                "testName":"杏仁玄米餅",
                "manufacture":"台東廠",
                "originPlace":"台灣",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"intertek",
                "paymentUnit":"tseyue",
                "samplingFrequency":"oddYear",
                "samplingTiming":false,
                "samplingDate":"2021-09-02T08:20:10.000Z"
            },
            {
                "product":"02",
                "testType":"rawMaterial",
                "rawMaterialTestName":"01",
                "manufacture":"原料1製造商",
                "originPlace":"美國",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301"]}],
                "testCompany":"intertek",
                "paymentUnit":"leezen",
                "samplingFrequency":"year",
                "samplingTiming":true,
                "samplingDate":"2021-09-02T08:20:10.000Z"
            }
        ],
        "remainingDays":-1
    },
    {
        "uuid": "7",
        "createdOn": "2021-12-17T22:15:00.000Z",
        "appNo": "21080101",
        "appType": "markReview",
        "phase": "documentReview",
        "activity": "documentReview_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "amountDefault": 1000,
        "amountModified": 1000,
        "assessmentPlaceList": [
            {
                "name": "台東廠",
                "address": "11501 台北市南港區三重路19-11號",
                "phone": "02-7723-8001",
            },
            {
                "name": "屏東廠",
                "address": "屏東縣恆春鎮海角路7號",
                "phone": "02-8787-5566",
            },
        ],
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 食安生技-椰子汁"},
                    {"item": "content", "information": "請參考原料說明"},
                    {"item": "spec", "information": "360ml/罐"},
                    {"item": "customerName", "information": "源天然股份有限公司"},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號"},
                    {"item": "phone", "information": "089-360960"},
                    {"item": "markLevel", "information": "潔淨"},
                    {"item": "otherAppeals", "information": "產地來源、成分、無添加宣稱、指標性成分宣稱、添加量宣稱..…等"},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf"
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf"
                    },
                ],
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 純在-蔬菜綜合果汁"},
                    {"item": "content", "information": "請參考原料說明"},
                    {"item": "spec", "information": "360ml/罐"},
                    {"item": "customerName", "information": "源天然股份有限公司"},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號"},
                    {"item": "phone", "information": "089-360960"},
                    {"item": "markLevel", "information": "潔淨"},
                    {"item": "otherAppeals", "information": "產地來源、成分、無添加宣稱、指標性成分宣稱、添加量宣稱..…等"},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf"
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf"
                    },
                ],
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
        ],
    },
    {
        "uuid": "8",
        "createdOn": "2021-12-17T22:15:00.000Z",
        "appNo": "21080102",
        "appType": "markReview",
        "phase": "documentReview",
        "activity": "documentReview_S20",
        "customerNo": "00006",
        "customerName": "黑松股份有限公司",
        "companyAddress": "新北市土城區藍天街7巷7號7樓",
        "companyPhone": "02-8967-6666",
        "amountDefault": 1000,
        "amountModified": 1000,
        "assessmentPlaceList": [
            {
                "name": "台東廠",
                "address": "11501 台北市南港區三重路19-11號",
                "phone": "02-7723-8001",
            },
            {
                "name": "屏東廠",
                "address": "屏東縣恆春鎮海角路7號",
                "phone": "02-8787-5566",
            },
        ],
        "markReviewProducts": [
            {
                "product": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 食安生技-椰子汁"},
                    {"item": "content", "information": "請參考原料說明"},
                    {"item": "spec", "information": "360ml/罐"},
                    {"item": "customerName", "information": "源天然股份有限公司"},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號"},
                    {"item": "phone", "information": "089-360960"},
                    {"item": "markLevel", "information": "潔淨"},
                    {"item": "otherAppeals", "information": "產地來源、成分、無添加宣稱、指標性成分宣稱、添加量宣稱..…等"},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf"
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf"
                    },
                ],
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
            {
                "product": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "changeDesc": "異動說明............",
                "reviewItems": [
                    {"item": "productName", "information": "Natural Benefits 純在-蔬菜綜合果汁"},
                    {"item": "content", "information": "請參考原料說明"},
                    {"item": "spec", "information": "360ml/罐"},
                    {"item": "customerName", "information": "源天然股份有限公司"},
                    {"item": "address", "information": "958台東縣池上鄉振興村11鄰145號"},
                    {"item": "phone", "information": "089-360960"},
                    {"item": "markLevel", "information": "潔淨"},
                    {"item": "otherAppeals", "information": "產地來源、成分、無添加宣稱、指標性成分宣稱、添加量宣稱..…等"},
                ],
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf"
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf"
                    },
                ],
                "reviewSupplementHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ],
                "rawMaterials": [
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)"
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "composition":"樹薯澱粉、水(原料)",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2,
                        "validityAndSituation":"有效日期：2023/04/18"
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3,
                        "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                            "當天使用有效日期2021.11.17(8/17進貨)"
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ],
            },
        ],
        "timeComplianceRate": "onTime",
    },
]

export default documentInboxes;